import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import { ROUTE_PLAN_BY_ID } from 'CorePackage/MainModule/routes/routes';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';

import styles from './KnmListByPlanHeader.module.scss';

interface IKnmListByPlanHeaderProps {
  plan?: IKnmPlan;
}

export const KnmListByPlanHeaderWithoutStore = ({ plan }: IKnmListByPlanHeaderProps) => {
  const { id: planId } = useParams<{ id: string }>();

  return (
    <div className={styles.KnmListByPlanHeader}>
      <div className={styles.TitleBlock}>
        <Link className={styles.BackButton} to={ROUTE_PLAN_BY_ID(planId)}>
          <span className={styles.BackButtonIcon} />
        </Link>
        <div className={styles.Title}>
          Просмотр плана № {planId} {plan?.startDate && `на ${new Date(plan?.startDate).getFullYear()} год`}
        </div>
        <Tooltip
          placement="right"
          content={
            <div className={styles.TooltipContent}>
              <div className={styles.TooltipItem}>{plan?.knoName}</div>
              <div className={styles.TooltipItem}>{plan?.prosecName}</div>
            </div>
          }
        >
          <span className={styles.TooltipIcon} />
        </Tooltip>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  plan: state.plan.data,
});

export const KnmListByPlanHeader = connect(mapStateToProps)(KnmListByPlanHeaderWithoutStore);
